import { useContext, useEffect, useRef, useState } from "react";
import SetHumidity from "../../constants/SetHumidity";
import HumidityChanges from "../../constants/HumidityChange";
import { Context } from "../../context/Context";

const ScenarioHumiditySetTempModal = ({
  selectValue,
  setTemp,
  setDiff,
  type,
}) => {
  const { setSetHumidityModal } = useContext(Context);
  const [value, setValue] = useState(selectValue);
  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setSetHumidityModal(modalName);
  }, []);

  const renderOptionsOfSelect = () => {
    if (type == 1) {
      // Set Temprature
      return SetHumidity.map((temp) => {
        if (temp.value == selectValue) {
          return (
            <option value={temp.value} selected="selected">
              {temp.name}
            </option>
          );
        }
        return <option value={temp.value}>{temp.name}</option>;
      });
    } else if (type == 2) {
      // Temprature Changes
      return HumidityChanges.map((chng) => {
        if (chng.value == selectValue) {
          return (
            <option value={chng.value} selected="selected">
              {chng.name}
            </option>
          );
        }
        return <option value={chng.value}>{chng.name}</option>;
      });
    }
  };

  const handleSubmit = () => {
    if (type == 1) {
      setTemp(value);
    } else if (type == 2) {
      setDiff(value);
    }
    closeButton.current.click();
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="scenarioTimerModal"
      tabIndex="-1"
      aria-labelledby="scenarioTimerModalLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "400px" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="equipmentsNameLable">
              {type == 1 ? "رطوبت تنظیم (%)" : "تغییرات رطوبت (%)"}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <select
                id="timerSelect"
                className="form-select w-100"
                data-style="btn-default"
                value={value}
                onChange={(e) => setValue(e.target.value)}
              >
                {renderOptionsOfSelect()}
              </select>
            </div>
            <div>
              {/* <button
                type="button"
                className="btn btn-success-app mb-2"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeButton}
              >
                انصراف
              </button> */}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success-app me-3 mb-2"
              onClick={handleSubmit}
            >
              ثبت
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScenarioHumiditySetTempModal;
